import * as T from './loyaltyProgramTypes';
import type { LoyaltyProgramAction } from './loyaltyProgramActions';

export interface LoyaltyProgramState {
  program: any | null;
  accrualConfig: any | null;
  specialRewards: any | null;
  loading: boolean;
  saving: boolean;
  error: string | null;
  setupComplete: boolean;
}

const initialState: LoyaltyProgramState = {
  program: null,
  accrualConfig: null,
  specialRewards: null,
  loading: false,
  saving: false,
  error: null,
  setupComplete: false,
};

export default function loyaltyProgramReducer(
  state = initialState,
  action: LoyaltyProgramAction
): LoyaltyProgramState {
  switch (action.type) {
    case T.FETCH_LOYALTY_PROGRAM_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_LOYALTY_PROGRAM_SUCCESS:
      return { ...state, loading: false, program: action.payload };
    case T.FETCH_LOYALTY_PROGRAM_FAILURE:
      return { ...state, loading: false, error: action.payload, program: null };

    case T.CREATE_LOYALTY_PROGRAM_REQUEST:
      return { ...state, saving: true, error: null };
    case T.CREATE_LOYALTY_PROGRAM_SUCCESS:
      return { ...state, saving: false, program: action.payload };
    case T.CREATE_LOYALTY_PROGRAM_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.UPDATE_LOYALTY_PROGRAM_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_LOYALTY_PROGRAM_SUCCESS:
      return { ...state, saving: false, program: action.payload };
    case T.UPDATE_LOYALTY_PROGRAM_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.UPDATE_LOYALTY_PROGRAM_STATUS_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_LOYALTY_PROGRAM_STATUS_SUCCESS:
      return { ...state, saving: false, program: action.payload };
    case T.UPDATE_LOYALTY_PROGRAM_STATUS_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.FETCH_LOYALTY_ACCRUAL_CONFIG_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_LOYALTY_ACCRUAL_CONFIG_SUCCESS:
      return { ...state, loading: false, accrualConfig: action.payload };
    case T.FETCH_LOYALTY_ACCRUAL_CONFIG_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.UPDATE_LOYALTY_ACCRUAL_CONFIG_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_LOYALTY_ACCRUAL_CONFIG_SUCCESS:
      return { ...state, saving: false, accrualConfig: action.payload };
    case T.UPDATE_LOYALTY_ACCRUAL_CONFIG_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.FETCH_LOYALTY_SPECIAL_REWARDS_REQUEST:
      return { ...state, loading: true, error: null };
    case T.FETCH_LOYALTY_SPECIAL_REWARDS_SUCCESS:
      return { ...state, loading: false, specialRewards: action.payload };
    case T.FETCH_LOYALTY_SPECIAL_REWARDS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case T.UPDATE_LOYALTY_SPECIAL_REWARDS_REQUEST:
      return { ...state, saving: true, error: null };
    case T.UPDATE_LOYALTY_SPECIAL_REWARDS_SUCCESS:
      return { ...state, saving: false, specialRewards: action.payload };
    case T.UPDATE_LOYALTY_SPECIAL_REWARDS_FAILURE:
      return { ...state, saving: false, error: action.payload };

    case T.CLEAR_LOYALTY_PROGRAM_ERROR:
      return { ...state, error: null };

    case T.SET_SETUP_COMPLETE:
      return { ...state, setupComplete: action.payload };

    case T.UPDATE_PROGRAM_LOCAL:
      return {
        ...state,
        program: state.program
          ? { ...state.program, ...action.payload, updatedAt: new Date().toISOString() }
          : null,
      };
    case T.TOGGLE_PROGRAM_STATUS:
      return {
        ...state,
        program: state.program
          ? {
              ...state.program,
              status: state.program.status === 'active' ? 'paused' : 'active',
              updatedAt: new Date().toISOString(),
            }
          : null,
      };
    case T.ADD_ITEM_RULE:
      return {
        ...state,
        program: state.program
          ? {
              ...state.program,
              itemRules: [...(state.program.itemRules ?? []), { ...action.payload, id: crypto.randomUUID() }],
              updatedAt: new Date().toISOString(),
            }
          : null,
      };
    case T.UPDATE_ITEM_RULE:
      return {
        ...state,
        program: state.program
          ? {
              ...state.program,
              itemRules: (state.program.itemRules ?? []).map((r: any) =>
                r.id === action.payload.id ? { ...r, ...action.payload.updates } : r
              ),
              updatedAt: new Date().toISOString(),
            }
          : null,
      };
    case T.REMOVE_ITEM_RULE:
      return {
        ...state,
        program: state.program
          ? {
              ...state.program,
              itemRules: (state.program.itemRules ?? []).filter((r: any) => r.id !== action.payload),
              updatedAt: new Date().toISOString(),
            }
          : null,
      };

    default:
      return state;
  }
}
